import { signupSchema } from '@alicerce/contracts';
import { Alert, Button, PasswordField, TextField } from '@alicerce/ui';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useZodForm } from '@/lib/form';
import { useSession } from '@/lib/session';
import { AuthLayout, withPasswordConfirmation } from './layout';
import { safeNext } from './login';

const signupFormSchema = withPasswordConfirmation(signupSchema);

export function SignupPage() {
  const { api, startSession } = useSession();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const form = useZodForm(signupFormSchema, { name: '', email: '', password: '', passwordConfirmation: '' });
  const next = params.get('next');

  const onSubmit = form.submit(async ({ passwordConfirmation: _confirm, ...data }) => {
    const res = await api.post<{ accessToken: string }>('/v1/auth/signup', data, { noTenant: true });
    await startSession(res.accessToken);
    // Quem veio de um convite volta para ele; os demais cadastram o negócio.
    navigate(next ? safeNext(next) : '/novo-negocio', { replace: true });
  });

  return (
    <AuthLayout
      title="Criar conta"
      subtitle="14 dias grátis, sem cartão."
      backToSite
      footer={
        <>
          Já tem conta?{' '}
          <Link className="font-medium text-brand-700 hover:underline" to={`/entrar${next ? `?next=${encodeURIComponent(next)}` : ''}`}>
            Entrar
          </Link>
        </>
      }
    >
      <form className="space-y-4" onSubmit={onSubmit} noValidate>
        {form.formError && <Alert tone="danger">{form.formError}</Alert>}
        <TextField label="Seu nome" autoComplete="name" value={form.values.name} error={form.errors.name} onChange={(e) => form.set('name', e.target.value)} />
        <TextField label="E-mail" type="email" autoComplete="email" value={form.values.email} error={form.errors.email} onChange={(e) => form.set('email', e.target.value)} />
        <PasswordField
          label="Senha"
          autoComplete="new-password"
          hint="Pelo menos 8 caracteres."
          value={form.values.password}
          error={form.errors.password}
          onChange={(e) => form.set('password', e.target.value)}
        />
        <PasswordField
          label="Confirmar senha"
          autoComplete="new-password"
          value={form.values.passwordConfirmation}
          error={form.errors.passwordConfirmation}
          onChange={(e) => form.set('passwordConfirmation', e.target.value)}
        />
        <Button type="submit" className="w-full" loading={form.submitting}>
          Criar conta
        </Button>
      </form>
    </AuthLayout>
  );
}
